<div class="flex flex-col w-full gap-1">
    @if (label) {
        <label [attr.for]="id" class="font-bold text-black">{{ label }}</label>
    }
    <textarea
        [id]="id"
        [placeholder]="placeholder"
        [rows]="rows"
        [disabled]="isReadOnly || isDisabledByForm"
        [(ngModel)]="value"
        (blur)="onBlur.emit($event)"
        (keypress)="onKeypress.emit($event)"
        autocomplete="off"
        [attr.maxlength]="maxLength"
        [ngClass]="{ 'border-red-500': campoInvalido, 'border-gray-300': !campoInvalido }"
        class="w-full bg-white border px-3 py-2 text-sm rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-300"
    ></textarea>
</div>
